'use client';

import {useState} from 'react';
import {API_CONTACT_FORM_SUBMISSION_NEW} from "@constants/api-endpoints/contact-form";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import {BACKEND_EP_CONTACT_SUBMISSION_NEW} from "../../../constants/backend-endpoints/contact-form";

export default function ContactForm() {
   const [formData, setFormData] = useState({
      name: '',
      email: '',
      subject: '',
      message: '',
   });
   
   const {executeRecaptcha} = useGoogleReCaptcha();
   
   const [status, setStatus] = useState(null);
   const [submissionMessage, setSubmissionMessage] = useState(null);
   
   const handleChange = (e) => {
      setFormData({...formData, [e.target.name]: e.target.value});
   };
   
   const handleSubmit = async (e) => {
      e.preventDefault();
      setStatus('submitting');
      
      try {
         
         const response = await fetch(BACKEND_EP_CONTACT_SUBMISSION_NEW, {
            method: 'POST',
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json',
            },
            body: JSON.stringify({
               ...formData,
               recaptchaToken: await executeRecaptcha('contact_form'),
            }),
         });
         
         if(!response.ok) {
            
            const json = await response.json();
            
            if(response.status === 422 && json.errors) {
               throw new Error(json.errors?.map(error => error.message).join(', '));
            }
            
            throw new Error(
               json.message || 'An error occurred while submitting the form. Please try again later.'
            )
            
         }
         
         const responseData = await response.json();
         
         if(responseData.success) {
            setStatus('success');
            setFormData({name: '', email: '', subject: '', message: ''});
            setSubmissionMessage(responseData.message);
         } else {
            setStatus('error');
            setSubmissionMessage(responseData.message);
         }
         
         
      } catch (error) {
         setStatus('error');
         setSubmissionMessage(error.message || 'An error occurred while submitting the form. Please try again later.');
      }
   };
   
   return (
      
      <>
         <h2 className="text-center mb-4">Send Us a Message</h2>
         {status === 'success' && (
            <div className="alert alert-success" role="alert">
               {submissionMessage || 'Your message has been sent successfully!'}
            </div>
         )}
         {status === 'error' && (
            <div className="alert alert-danger" role="alert">
               {submissionMessage || 'An error occurred while submitting the form. Please try again later.'}
            </div>
         )}
         <form onSubmit={handleSubmit} className="card shadow-lg p-4 border-0">
            <div className="mb-3">
               <label htmlFor="formName" className="form-label">Name</label>
               <input
                  type="text"
                  className="form-control"
                  id="formName"
                  placeholder="Enter your name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
               />
            </div>
            
            <div className="mb-3">
               <label htmlFor="formEmail" className="form-label">Email address</label>
               <input
                  type="email"
                  className="form-control"
                  id="formEmail"
                  placeholder="Enter your email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
               />
            </div>
            
            <div className="mb-3">
               <label htmlFor="formSubject" className="form-label">Subject</label>
               <input
                  type="text"
                  className="form-control"
                  id="formSubject"
                  placeholder="Subject of your message"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
               />
            </div>
            
            <div className="mb-3">
               <label htmlFor="formMessage" className="form-label">Message</label>
               <textarea // Replaced <Form.Control as="textarea">
                  className="form-control"
                  id="formMessage"
                  rows="5"
                  placeholder="Your message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  maxLength={2048}
               ></textarea>
            </div>
            
            <button type="submit" className="btn btn-success" disabled={status === 'submitting'}>
               {status === 'submitting' ? 'Sending...' : 'Send Message'}
            </button>
         </form>
      </>
   );
}